import axios from "axios";

const baseURL = import.meta.env.VITE_API_BASE_URL || "/api";

export const api = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

// Token-provider wordt door AuthGate gezet zodra MSAL een account heeft.
// Bij SKIP_AUTH (dev) blijft hij null en gaat elke call zonder Authorization.
type TokenProvider = () => Promise<string | null>;
let tokenProvider: TokenProvider | null = null;
let unauthorizedHandler: (() => void) | null = null;

export function setTokenProvider(fn: TokenProvider | null) {
  tokenProvider = fn;
}

export function setUnauthorizedHandler(fn: (() => void) | null) {
  unauthorizedHandler = fn;
}

api.interceptors.request.use(async (config) => {
  if (tokenProvider) {
    const token = await tokenProvider();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 401 && unauthorizedHandler) {
      console.warn("[api] 401 — opnieuw inloggen");
      unauthorizedHandler();
    }
    return Promise.reject(err);
  }
);
